import type { ChangeEvent } from 'react';
import type { MailingAddress } from '@/lib/types';

/**
 * The household's mailing address, asked with the form's questions when MP's
 * "Get Address Info" is on. Starts from what MP holds.
 */
export function AddressFields({
  value,
  onChange,
}: {
  value: MailingAddress;
  onChange: (next: MailingAddress) => void;
}) {
  const set = (k: keyof MailingAddress) => (e: ChangeEvent<HTMLInputElement>) =>
    onChange({ ...value, [k]: e.target.value });
  return (
    <section className="space-y-2">
      <h3 className="text-navy text-[0.92rem] font-bold">
        Mailing address<span className="text-rose ml-1">*</span>
      </h3>
      <input
        className="field"
        placeholder="Street address"
        value={value.line1}
        onChange={set('line1')}
        autoComplete="address-line1"
        maxLength={75}
      />
      <input
        className="field"
        placeholder="Apartment, suite, etc."
        value={value.line2}
        onChange={set('line2')}
        autoComplete="address-line2"
        maxLength={75}
      />
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-[1fr_5.5rem_7rem]">
        <input
          className="field"
          placeholder="City"
          value={value.city}
          onChange={set('city')}
          autoComplete="address-level2"
          maxLength={50}
        />
        <div className="grid grid-cols-2 gap-2 sm:contents">
          <input
            className="field"
            placeholder="State"
            value={value.state}
            onChange={set('state')}
            autoComplete="address-level1"
            maxLength={50}
          />
          <input
            className="field"
            placeholder="ZIP code"
            value={value.postalCode}
            onChange={set('postalCode')}
            autoComplete="postal-code"
            inputMode="numeric"
            maxLength={15}
          />
        </div>
      </div>
    </section>
  );
}
